<template>
  <div :aria-busy="resource.loading">
    <template v-if="newUi">
      <AppContentSkeleton v-if="resource.loading" :label="`Loading ${label}`" layout="block" />
      <AppErrorState v-else-if="resource.error" :message="resource.error" @retry="$emit('reload')" />
      <slot v-else-if="resource.data" :data="resource.data" />
    </template>
    <template v-else>
    <div
      v-if="resource.loading"
      class="automation-skeleton"
      :class="{ 'automation-skeleton--filters automation-list-filters': skeleton === 'filters' }"
      role="status"
      :aria-label="`Loading ${label}…`"
    >
      <div v-for="index in 6" :key="index" aria-hidden="true">
        <span v-if="skeleton === 'filters'" class="automation-skeleton-label" />
        <span class="automation-skeleton-bar" />
      </div>
    </div>
    <div v-else-if="resource.error" class="automation-error" role="alert">
      <p>{{ resource.error }}</p>
      <AppButton design="new" theme="dark" @click.native="$emit('reload')">Reload {{ label }}</AppButton>
    </div>
    <slot v-else-if="resource.data" :data="resource.data" />
    </template>
  </div>
</template>
<script>
import AppContentSkeleton from '@/components/AppContentSkeleton.vue'
import AppErrorState from '@/components/AppErrorState.vue'
export default {
  components: { AppContentSkeleton, AppErrorState },
  props: {
    newUi: Boolean,
    resource: { type: Object, required: true },
    label: { type: String, default: 'data' },
    skeleton: { type: String, default: 'rows', validator: value => ['rows', 'filters'].includes(value) }
  }
}
</script>
<style scoped lang="scss">
.automation-skeleton {
  display: grid;
  gap: $ui-space-16;
  padding: $ui-space-24;
}
.automation-skeleton-bar,
.automation-skeleton-label {
  display: block;
  border-radius: $ui-control-radius;
  background: $ui-line;
}
.automation-skeleton-bar {
  height: 32px;
}
.automation-skeleton-label {
  width: 35%;
  height: $ui-font-size-metadata * 1.4;
  margin-bottom: $ui-space-8;
}
.automation-skeleton--filters {
  padding: 0;
}
.automation-skeleton--filters .automation-skeleton-bar {
  height: $ui-control-height;
}
.automation-error {
  padding: $ui-space-16;
  color: $ui-red;
}
.automation-error p {
  margin: 0 0 $ui-space-12;
  overflow-wrap: anywhere;
}
</style>
